import React, { PropsWithChildren } from 'react';
import { Text } from '@ydistri/ds';

const CalculationTableText: React.FC<PropsWithChildren> = ({ children }) => {
  return <Text $size="large">{children}</Text>;
};

export default CalculationTableText;
